
import { SubDomain } from "../../../SubDomain.js";
import RepairResult from "./RepairResult.js";

export default class RepairResultsDomain extends SubDomain {
  
  constructor(domain, storage) {
    super(domain, RepairResult.MODEL_NAME);
    this.storage = storage;
  }

  list() {
    return this.storage.list;
  }
  
  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        return new RepairResult(this.domain, item);
      }
    }

    return new RepairResult(this.domain);
  }
}